module.exports = __webpack_public_path__ + "img/nav-logo2.d4ae8300.png";